import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import moment from "moment-timezone";
import includes from "lodash/includes";
import cloneDeep from "lodash/cloneDeep";

import { Header, List } from "../../../shared/GridComponents";
import formWrapper from "../../../shared/Form";
import Item from "./Item";
import FilterOptions from "./FilterOptions";

class TableUI extends Component {
	constructor(props) {
		super(props);
		this.url = props.match.url;
		this.push = props.history.push;
		this.loadIncrement = 10;
		this.state = {
			itemsToLoad: this.loadIncrement,
		};
	}

	componentDidMount() {
		const { formApi, appKey } = this.props;
		const _values = localStorage.getItem(`sessionFiltering-${appKey}`);
		const values = _values ? JSON.parse(_values) : {};
		const { timeZone } = values;
		const valuesToPass = {
			...values,
			timeZone: timeZone ? timeZone : moment.tz.guess(),
		};
		if (formApi) formApi.setValues(valuesToPass);
	}

	componentDidUpdate(prevProps) {
		const { values, appKey } = this.props;
		if (prevProps.values !== values) {
			localStorage.setItem(`sessionFiltering-${appKey}`, JSON.stringify(values));
			localStorage.setItem("timezone", values.timeZone);
		}
	}

	deleteItem = (id, name) => {
		this.props.delete(id, name);
	};

	createItem = () => {
		this.push(`${this.url}/new`);
	};

	createChildItem = (id, childItemValues) => {
		this.push({
			pathname: `${this.url}/new`,
			state: {
				parentId: id,
				...childItemValues,
			},
		});
	};

	duplicateItem = id => {
		this.push(`${this.url}/copy/${id}`);
	};

	editItem = id => {
		this.push(`${this.url}/${id}`);
	};

	loadMore = e => {
		e.preventDefault();
		const { itemsToLoad } = this.state;
		this.setState({
			itemsToLoad: itemsToLoad + this.loadIncrement,
		});
	};

	seeLess = e => {
		e.preventDefault();
		const { itemsToLoad } = this.state;
		const numberOfItems =
			itemsToLoad < this.loadIncrement * 2 ? this.loadIncrement : itemsToLoad - this.loadIncrement;
		this.setState({
			itemsToLoad: numberOfItems,
		});
	};

	shouldAddItem = item => {
		const { values } = this.props;
		const { startDate, endDate } = values;
		const { startsAt } = item;
		const afterStart = startDate ? moment(startsAt).isAfter(moment(startDate)) : true;
		const beforeEnd = endDate ? moment(startsAt).isBefore(moment(endDate)) : true;
		return afterStart && beforeEnd;
	};

	checkItemForFilter = (item, tags) => tags.every(tag => includes(item.tags, tag)) && this.shouldAddItem(item);

	filter = items => {
		const {
			values: { sessionsFilter },
		} = this.props;
		const filterBy = sessionsFilter ? sessionsFilter : [];
		let itemsToDisplay = [];

		if (items && filterBy) {
			let newItems = cloneDeep(items);
			for (let item of newItems) {
				let showParent = false;
				if ("childItems" in item) {
					// we need a list of child items that have the tags we're filtering by (their ID's)
					let showItems = item.childItems
						.filter(childItem => this.checkItemForFilter(childItem, filterBy))
						.map(i => i.id);
					item.childItems = item.childItems.filter(i => showItems.includes(i.id));
					// if we have any children we'll always show the parent (since it'll show the child)
					// else, we will still check the parent for the tag we are filtering by
					if (item.childItems.length > 0) {
						showParent = true;
					} else {
						showParent = this.checkItemForFilter(item, filterBy);
					}
				} else {
					showParent = this.checkItemForFilter(item, filterBy);
				}
				if (showParent) {
					itemsToDisplay.push(item);
				}
			}
		}

		return itemsToDisplay;
	};

	render() {
		const { items, values } = this.props;

		const { itemsToLoad } = this.state;

		const { timeZone } = values;

		const itemsToDisplay = items ? this.filter(cloneDeep(items)) : [];

		const CRUD = {
			createChildItem: this.createChildItem,
			deleteItem: this.deleteItem,
			duplicateItem: this.duplicateItem,
			editItem: this.editItem,
		};

		let defaultText;

		if (!items || (items && items.length === 0)) {
			defaultText = "Create your first session...";
		} else if (items && itemsToDisplay.length === 0) {
			defaultText = "There are no items that match your search criteria.";
		}

		return (
			<div>
				<Header pluralItemName="Sessions" createItem={this.createItem} />
				{items && <FilterOptions />}
				<List
					items={itemsToDisplay.slice(0, itemsToLoad)}
					defaultText={defaultText}
					renderItem={({ item }) => <Item key={item.id} item={item} crud={CRUD} timeZone={timeZone} />}
				/>
				<div className="button-list">
					{itemsToDisplay.length > itemsToLoad && (
						<button className="load-list btn btn-primary" onClick={e => this.loadMore(e)}>
							<h4>Load More...</h4>
						</button>
					)}
					{itemsToLoad > this.loadIncrement && (
						<button className="load-list btn btn-primary" onClick={e => this.seeLess(e)}>
							<h4>See Less</h4>
						</button>
					)}
				</div>
			</div>
		);
	}
}

TableUI.propTypes = {
	items: PropTypes.array.isRequired,
	match: PropTypes.object.isRequired,
	history: PropTypes.object.isRequired,
	delete: PropTypes.func.isRequired,
	pluralItemName: PropTypes.string,
	singleItemName: PropTypes.string,
	values: PropTypes.object.isRequired,
	formApi: PropTypes.object.isRequired,
	appKey: PropTypes.string.isRequired,
};

export default withRouter(formWrapper(TableUI, false));
